import { useRoleContext } from "./useRoleContext";
import { useSwrFetch } from "./useSwrFetch";

export function useMultiShipmentProjectBookingsAsShipper(
  shipmentId: number | undefined,
) {
  const { role } = useRoleContext();

  const url =
    role != null && shipmentId !== undefined
      ? `/shippers/${role.id}/projects/${shipmentId}/bookings`
      : null;

  const { data, loading, error, refetch } = useSwrFetch<
    MultiShipmentProjectBooking[]
  >({
    url,
    errorMessage: "Failed to fetch project bookings",
  });

  return {
    projectBookings: data ?? [],
    refetchBookings: refetch,
    loading,
    error,
    success: data !== undefined && error == null,
  };
}
